module.exports = __webpack_public_path__ + "img/Industrial Strength.17459de5.jpg";